import { settingsActions } from '@redux/slices/settings';
import { getAppDispatch } from '@utilities/dispatch.util';

const applicationVersionManipulationJson = ({ data }) => {
  const applicationVersion = data?.applicationVersion || '';
  let isAppUpdatable = false;
  let movingTasksAssetsReduxToIndexDBCompleted = false;

  if (localStorage.getItem('applicationVersion')) {
    if (applicationVersion != (localStorage.getItem('applicationVersion') || 0)) {
      isAppUpdatable = true;
      movingTasksAssetsReduxToIndexDBCompleted = false;
    }
  } else {
    isAppUpdatable = false;
    movingTasksAssetsReduxToIndexDBCompleted = true;
    localStorage.setItem('applicationVersion', applicationVersion);
  }

  return {
    isAppUpdatable,
    movingTasksAssetsReduxToIndexDBCompleted
  };
};

const applicationVersionDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(settingsActions.setAppUpdateStatus({ isAppUpdatable: data?.isAppUpdatable }));
  dispatch?.(
    settingsActions.setAppUpdateStatusForWorkOrder({
      movingTasksAssetsReduxToIndexDBCompleted: data?.movingTasksAssetsReduxToIndexDBCompleted
    })
  );
};

export { applicationVersionManipulationJson, applicationVersionDispatcher };
